/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// Caminho antigo da aba no legado (`router.tsx:1271-1290`): o link salvo cai no detalhe com `?tab=` (S29).
export const Route = createFileRoute('/_app/ccb/cessoes/$batchAssignmentId/documentos')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/ccb/cessoes/$batchAssignmentId', params, search: { tab: 'documentos' }, replace: true });
  },
});
